module.exports = __webpack_public_path__ + "static/ukulele-a05810f769ee176afbde1d1a0cb9ec88.jpg";